import * as React from 'react';
import { ConsentPolicyWrapper } from '@wix/thunderbolt-elements/src/components/ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';
import type {
  IHtmlComponentImperativeActions,
  IHtmlComponentProps,
} from '../../../HtmlComponent.types';
import HtmlComponent from '../../HtmlComponent';
import { DEFAULT_CONSENT_POLICY } from '../../constants';
import styles from '../../styles/HtmlComponent.module.scss';
import classNames from 'clsx';

const HtmlComponentPropsWithConsentWrapper: React.ForwardRefRenderFunction<
  IHtmlComponentImperativeActions,
  IHtmlComponentProps
> = (props, forwardRef) => {
  const { className, componentConsentPolicy, ...restProps } = props;

  return (
    <ConsentPolicyWrapper
      componentConsentPolicy={{
        [componentConsentPolicy ?? DEFAULT_CONSENT_POLICY]: true,
      }}
      rootClassName={classNames(styles.root, className)}
      {...restProps}
    >
      <HtmlComponent ref={forwardRef} {...props} />
    </ConsentPolicyWrapper>
  );
};

export default React.forwardRef(HtmlComponentPropsWithConsentWrapper);
